var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('ckeditor',{staticClass:"ckeditor",attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.editorChange,"ready":_vm.onReady},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }